module.exports = __webpack_public_path__ + "img/bus.8e85a36c.svg";